import React from 'react';
import { TemplateBuilderContainer } from './Components/TemplateBuilderContainer';
import {
  TemplateBuilder,
  TemplateBuilderFactory,
} from './Components/TemplateBuilderFactory';
import { TemplateBuilderInputTriggerSection } from './Components/TemplateBuilderInputTriggerSection';
import { TemplateBuilderReengagementSection } from './Components/TemplateBuilderReengagementSection';
import { TemplateSubsectionLink } from './Components/TemplateSubsectionLink';

export const GiftGiveawayBuilder: TemplateBuilder = ({ maxFollowUpCounts }) => (
  <TemplateBuilderFactory
    template="gift_giveaway"
    enabledCollectionOptions={['email', 'phone', 'mailing_address']}
    {...maxFollowUpCounts}
  >
    {props => {
      return (
        <TemplateBuilderContainer
          enabled={!props.busy && props.isValid}
          confirm={props.confirm}
        >
          <TemplateBuilderInputTriggerSection>
            <div>
              On {props.channelName}, when someone {props.triggersSelect}, send{' '}
              {props.channelMessageName} asking for their contest entry
              information including {props.collectionSelect}, then ask them{' '}
              {props.qualifyingQuestionSelect}, then send them a confirmation of
              their entry and a thank you for entering.
            </div>
          </TemplateBuilderInputTriggerSection>
          <TemplateSubsectionLink />
          <TemplateBuilderReengagementSection>
            <div>
              Using the data collected from {props.channelName}, if the user
              completed their entry, send them a {props.unicornEmailSelect}{' '}
              Email and {props.unicornSMSSelect} SMS text message sequence to
              create awareness and build brand affinity with contest
              registrants.
            </div>
          </TemplateBuilderReengagementSection>
        </TemplateBuilderContainer>
      );
    }}
  </TemplateBuilderFactory>
);
